// extracted by mini-css-extract-plugin
export default {"root":"OAbNaodkA_JPAztkdd4_","fullHeight":"ms_dORHGWzoUN64fP_sL","issueDescription":"qnkRfpjXTRbOh5Ic94MF","email":"zY0iiSGWoUT2W9Ix8gk9","title":"MELef8gZgl73FS2xnQjW"};